import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Products
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getBrands = () => api.get('/brands');
export const getCategories = () => api.get('/categories');
export const seedDatabase = () => api.post('/seed');

// Wishlist
export const getWishlist = () => api.get('/wishlist');
export const addToWishlist = (productId) => api.post(`/wishlist/${productId}`);
export const removeFromWishlist = (productId) => api.delete(`/wishlist/${productId}`);

// Reviews
export const getReviews = (productId) => api.get(`/reviews/${productId}`);
export const createReview = (data) => api.post('/reviews', data);

// Price Alerts
export const getPriceAlerts = () => api.get('/price-alerts');
export const createPriceAlert = (data) => api.post('/price-alerts', data);
export const deletePriceAlert = (alertId) => api.delete(`/price-alerts/${alertId}`);

// Size Guide
export const getSizeGuide = (category) => api.get(`/size-guide/${category}`);

// Subscriptions
export const createSubscriptionCheckout = (plan, originUrl) => 
  api.post('/subscriptions/create-checkout', null, { params: { plan, origin_url: originUrl } });
export const getSubscriptionStatus = (sessionId) => api.get(`/subscriptions/status/${sessionId}`);

export default api;
